import React from "react";
import { Card, Badge, Button } from "antd";
import ShowCapability from "./ShowCapability";
import EditCapability from "./EditCapabilityButton";
import DeleteCapability from "./DeleteCapabilityButton";
import { Grid } from "@material-ui/core";

export const CapabilityCard = ({ item }) => {
    return (
        <Card
            title={<Badge status="processing" text={item.name} />}
            style={{
                marginBottom: 15,
                minWidth: 300,
                boxShadow: "1px 1px 1px #9E9E9E",
                borderRadius: "5px",
            }}
            bordered={true}
            extra={
                <Button
                    style={{
                        backgroundColor: item.permission === "deny" ? "red" : item.permission === "grant" ? "blue" : undefined,
                        borderColor: item.permission === "deny" ? "red" : item.permission === "grant" ? "blue" : undefined,
                        color: item.permission === "deny" ? "white" : item.permission === "grant" ? "white" : undefined,
                        pointerEvents: "none", // Ensures the button is disabled from interaction
                        opacity: item.permission ? 0.7 : 1 // Adjusts opacity to indicate disabled state
                    }}
                >
                    {item.permission}
                </Button>
            }
            actions={[
                <ShowCapability item={item} key="view" />,
                <EditCapability item={item} key="edit" />,
                <DeleteCapability item={item} key="delete" />,
            ]}
        >
            <Grid container direction="column" justify="center" alignItems="center">
                <h1>{item.name}</h1>
            </Grid>
        </Card>
    );
};

export default CapabilityCard;
